import { CopyButton } from "@/components/CopyButton"
import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"

/**
 * A coach's own shareable link, sitting directly under the section tabs.
 *
 * Two pages carry one of these — the story link on Users, the registration link
 * on Prospects — and they are the same feature wearing different clothes, so
 * they share a component rather than two lookalikes that drift. Both render
 * below the tabs: the tabs navigate between sections, so anything above them
 * reads as belonging to all three.
 *
 * Renders nothing without a `url`, since a coach with no slug has no link.
 */
export function ShareableLinkCard({ icon: Icon, title, description, url, copyLabel = "Copy link" }) {
  if (!url) return null

  return (
    <Card>
      <CardContent className="p-4">
        <p className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-wide text-zinc-500">
          {Icon && <Icon className="h-3.5 w-3.5 text-kf-red" />}
          {title}
        </p>
        <p className="mt-1 text-sm text-zinc-600">{description}</p>
        {/* The link is one long unbreakable token, so the button drops below it
            on a narrow screen rather than squeezing the field to nothing. */}
        <div className="mt-2 flex flex-col gap-2 sm:flex-row">
          <Input
            value={url}
            readOnly
            onFocus={(event) => event.target.select()}
            className="min-w-0 font-mono text-xs"
          />
          <CopyButton text={url} label={copyLabel} />
        </div>
      </CardContent>
    </Card>
  )
}
